// src/packages/viriyah/non-motor/viriyah_cargo_inland_020/CargoInlandCard.jsx
import React from "react";
import "./cargo_inland.css";

export default function CargoInlandCard({ onSelect }) {
  return (
    <div className="pkg-card cargo-inland">
      <div className="pkg-body">
        <h3>วิริยะ — Inland Transit (020)</h3>
        <p>ประกันภัยสินค้าที่ขนส่งภายในประเทศ • เลือกคุ้มครอง “ระบุภัย” หรือ “เสี่ยงภัยทุกชนิด”</p>

        <ul className="pkg-list">
          <li>คุ้มครองทั้งทางบก/เรือ/รถไฟ/เครื่องบิน</li>
          <li>ทำรายเที่ยว (Voyage) หรือรายระยะเวลา (Time) ได้</li>
          <li>มีตารางเบี้ยตามวงเงินเอาประกันและ “กลุ่มสินค้า”</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect} aria-label="ดูรายละเอียด Inland Transit">
          ดูรายละเอียด
        </button>
      </div>
    </div>
  );
}
